import { useReactOidc } from '@axa-fr/react-oidc-context';
import { AbstractInstanceType, Resource, RestEndpoint, SchemaDetail } from '@rest-hooks/rest';

/**Overwrites create to update continually */
export abstract class BaseAuthenticationResource extends Resource {
  static bearerToken?: string; // Used for authenticate to api endpoints

  static create<T extends typeof Resource>(
    this: T
  ): RestEndpoint<
    (this: RestEndpoint, first: any, second?: any) => Promise<any>,
    SchemaDetail<AbstractInstanceType<T>>,
    true
  > {
    const list = this.list();
    return super.create().extend({
      getOptimisticResponse: (snap, params, body) => body,
      update: (newResourcePk: string) => ({
        [list.key({})]: (resourcePks: string[] = []) => [...resourcePks, newResourcePk]
      })
    });
  }

  static useFetchInit = (init: RequestInit) => {
    const uro = useReactOidc();
    const token = uro?.oidcUser?.id_token;
    return {
      ...init,
      headers: {
        ...init.headers,
        Authorization: `Bearer ${token}`
      }
    };
  };

  static getFetchInit(init: Readonly<RequestInit>): RequestInit {
    const headers = (
      init.headers
        ? {
            ...init.headers
          }
        : {}
    ) as Record<string, string>;
    if (this.bearerToken) {
      headers['Authorization'] = `Bearer ${this.bearerToken}`;
    }

    return {
      ...init,
      credentials: 'same-origin',
      headers: headers
    };
  }
}
